import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { providePrimeNG } from 'primeng/config';
import { ConfirmDialogModule } from 'primeng/confirmdialog'; // ← IMPORT
import { ConfirmationService, MessageService } from 'primeng/api';

import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { PdfLoadingOverlayComponent } from './shared/components/pdf-loading-overlay/pdf-loading-overlay.component';

import { HttpClient, provideHttpClient, HTTP_INTERCEPTORS, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import Aura from '@primeng/themes/aura';

import { ChecklistModule } from './modules/checklist/checklist.module';
import { TranslationService } from './translation/translation.service';
import { IMAGE_CONFIG } from '@angular/common';
// import { CredentialsInterceptor } from 'src/credentials.interceptor';
import { CookieService } from 'ngx-cookie-service';
import { provideFirebaseApp } from '@angular/fire/app';
import { initializeApp } from 'firebase/app';
import { provideMessaging } from '@angular/fire/messaging';
import { getMessaging } from 'firebase/messaging';
import { ServiceWorkerModule, SwUpdate, VersionEvent } from '@angular/service-worker';
import { authInterceptor } from './core/interceptor/auth-interceptor';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { environment } from '../environments/environment';
// import { environment } from 'src/environments/environment';

const tempTranslationService = new TranslationService();
const primeNGTranslations = tempTranslationService.getAllTranslations();

@NgModule({
    declarations: [AppComponent, PdfLoadingOverlayComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        LayoutModule,
        CoreModule,
        SharedModule,
        ChecklistModule,
        ProgressSpinnerModule,
        ConfirmDialogModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.sw === true,
            registrationStrategy: 'registerImmediately'
        })
    ],
    providers: [
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideMessaging(() => getMessaging()),
        provideHttpClient(withInterceptors([authInterceptor])),
        provideAnimationsAsync(),
        providePrimeNG({
            ripple: true,
            inputStyle: 'outlined', // o 'filled'
            theme: {
                preset: Aura,
                options: {
                    darkModeSelector: '.app-dark', // usa sistema operativo para modo oscuro
                    prefix: 'p', // prefijo para clases CSS de PrimeNG
                    cssLayer: {
                        name: 'primeng',
                        order: 'tailwind-base, primeng, tailwind-utilities'
                    }
                }
            },
            zIndex: {
                modal: 1200,
                overlay: 1000,
                menu: 1000,
                tooltip: 1100
            },
            translation: primeNGTranslations
        }),
        ConfirmationService,
        MessageService,
        {
            provide: IMAGE_CONFIG,
            useValue: {
                disableImageSizeWarning: true, // silencia el warning de tamaño excesivo
                disableImageAspectRatioWarning: true // silencia el warning de aspect-ratio
            }
        },
        // {
        //     provide: HTTP_INTERCEPTORS,
        //     useClass: CredentialsInterceptor,
        //     multi: true
        // },
        CookieService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(swUpdate: SwUpdate, confirm: ConfirmationService) {
        if (swUpdate.isEnabled) {
            swUpdate.versionUpdates.subscribe(async (event: VersionEvent) => {
                if ((event as any).type !== 'VERSION_READY') return;

                const isIOS = /iP(ad|hone|od)/.test(navigator.userAgent);
                const isStandalone = (window.navigator as any).standalone || window.matchMedia('(display-mode: standalone)').matches;

                // iOS PWA: usar confirm nativo del SO (bloqueante y visible) para pedir actualización
                if (isIOS && isStandalone) {
                    const accepted = window.confirm('Nueva Versión del Sistema\n\n¿Actualizar ahora?');
                    if (accepted) {
                        try {
                            await swUpdate.activateUpdate();
                        } catch {}
                        location.reload();
                    }
                    return;
                }

                // Web / Android: usar diálogo PrimeNG
                confirm.confirm({
                    header: 'Nueva Versión del Sistema',
                    message: 'Hay una actualización disponible. ¿Actualizar ahora?',
                    acceptLabel: 'Actualizar',
                    rejectLabel: 'Luego',
                    accept: async () => {
                        try {
                            await swUpdate.activateUpdate();
                        } catch {}
                        location.reload();
                    }
                });
            });

            const checkForUpdate = () => void swUpdate.checkForUpdate().catch(() => undefined);
            checkForUpdate();
            setInterval(checkForUpdate, 5 * 60 * 1000);
            window.addEventListener('online', checkForUpdate);
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') checkForUpdate();
            });
        }
    }
}
